function buildUpgradeRoutes({
  routes,
  errorLoading,
  AsyncDomain,
  redirectToMyMusic,
  onEnterUpgradeFlow,
  onChangeUpgradeFlow,
  isLoggedInUser,
  createConditionalComponent,
  onEnterStationLanding,
  onEnterPlans,
}) {
  return routes.concat([
    {
      path: '/plans',
      onEnter: onEnterPlans,
      getComponent(location, cb) {
        cb(
          null,
          createConditionalComponent({
            condition: isLoggedInUser,
            ifTrueOptions: {
              domain: 'payments',
              component: 'Upgrade',
              key: 'Upgrade',
            },
            ifFalseOptions: {
              domain: 'payments',
              component: 'AnonUpgrade',
              key: 'AnonUpgrade',
            },
          }),
        );
      },
      indexRoute: {
        props: {
          domain: 'payments',
          component: 'Upgrade',
          key: 'Upgrade',
        },
        component: AsyncDomain,
      },
    },
    {
      path: '/upgrade',
      onEnter: onEnterUpgradeFlow,
      onChange: onChangeUpgradeFlow,
      getComponent(location, cb) {
        cb(
          null,
          createConditionalComponent({
            condition: isLoggedInUser,
            ifTrueOptions: {
              domain: 'payments',
              component: 'Upgrade',
              key: 'Upgrade',
            },
            ifFalseOptions: {
              domain: 'payments',
              component: 'AnonUpgrade',
              key: 'AnonUpgrade',
            },
          }),
        );
      },
      indexRoute: {
        props: {
          domain: 'payments',
          component: 'Upgrade',
          key: 'Upgrade',
        },
        component: AsyncDomain,
      },
      childRoutes: [
        {
          path: ':tierSlug',
          props: {
            domain: 'payments',
            component: 'Upgrade',
            key: 'Upgrade',
          },
          component: AsyncDomain,
          childRoutes: [
            {
              path: ':subTierSlug',
            },
          ],
        },
      ],
    },
  ]);
}

function buildSettingsRoutes({
  routes,
  onEnterSettings,
  errorLoading,
  onEnterSubscriptionManagement,
  AsyncDomain,
  onEnterFamilyPlanManagement,
  onEnterUpgradeFlow,
}) {
  const settingsChildRoutes = [
    {
      path: 'info',
      getComponent(location, cb) {
        System.import(
          /* webpackChunkName: "c_user-settings-account" */ `${BASE_PATH}/src/components/UserSettings/Account/Account`,
        )
          .then(module => {
            cb(null, module.default);
          })
          .catch(errorLoading);
      },
    },
    {
      path: 'notices',
      getComponent(location, cb) {
        System.import(
          /* webpackChunkName: "c_user-settings-notifications" */ `${BASE_PATH}/src/components/UserSettings/Notifications/Notifications`,
        )
          .then(module => {
            cb(null, module.default);
          })
          .catch(errorLoading);
      },
    },
    {
      path: 'content',
      getComponent(location, cb) {
        System.import(
          /* webpackChunkName: "c_user-settings-contentsettings" */ `${BASE_PATH}/src/components/UserSettings/ContentSettings/ContentSettings`,
        )
          .then(module => {
            cb(null, module.default);
          })
          .catch(errorLoading);
      },
    },
    {
      path: 'download-app',
      getComponent(location, cb) {
        System.import(
          /* webpackChunkName: "c_user-settings-download-app" */ `${BASE_PATH}/src/components/UserSettings/DesktopApp/DownloadApp`,
        )
          .then(module => {
            cb(null, module.default);
          })
          .catch(errorLoading);
      },
    },
    {
      path: 'subscription',
      onEnter: onEnterSubscriptionManagement,
      props: {
        domain: 'payments',
        component: 'Subscription',
        key: 'Subscription',
      },
      component: AsyncDomain,
    },
    {
      path: 'family/manage',
      onEnter: onEnterFamilyPlanManagement,
      props: {
        domain: 'payments',
        component: 'Subscription',
        key: 'Subscription',
      },
      component: AsyncDomain,
    },
    {
      path: 'family/invite',
      onEnter: onEnterFamilyPlanManagement,
      props: {
        domain: 'payments',
        component: 'Subscription',
        key: 'Subscription',
      },
      component: AsyncDomain,
    },
    {
      path: 'redeem',
      props: {
        domain: 'payments',
        component: 'Redeem',
        key: 'Redeem',
      },
      component: AsyncDomain,
    },
    {
      path: 'upgrade',
      onEnter: onEnterUpgradeFlow,
      props: {
        domain: 'payments',
        component: 'Upgrade',
        key: 'Upgrade',
      },
      component: AsyncDomain,
    },
  ];

  return routes.concat([
    {
      path: 'settings',
      onEnter: onEnterSettings,
      getComponent(location, cb) {
        System.import(
          /* webpackChunkName: "c_user-settings" */ `${BASE_PATH}/src/containers/UserSettings/UserSettings`,
        )
          .then(module => {
            cb(null, module.default);
          })
          .catch(errorLoading);
      },
      getIndexRoute(location, cb) {
        System.import(
          /* webpackChunkName: "c_user-settings-account" */ `${BASE_PATH}/src/components/UserSettings/Account/Account`,
        )
          .then(module => {
            cb(null, { component: module.default });
          })
          .catch(errorLoading);
      },
      childRoutes: settingsChildRoutes,
    },
  ]);
}

function buildMobileSettingsRoutes({
  routes,
  onEnterSettings,
  errorLoading,
  onEnterSubscriptionManagement,
  AsyncDomain,
  onEnterMobileMessage,
  isResponsiveSubscriptionEnabled,
}) {
  const settingsChildRoutes = isResponsiveSubscriptionEnabled()
    ? [
        {
          path: 'subscription',
          onEnter: onEnterSubscriptionManagement,
          props: {
            domain: 'payments',
            component: 'Subscription',
            key: 'Subscription',
          },
          component: AsyncDomain,
        },
      ]
    : [
        {
          path: 'subscription',
          onEnter: onEnterMobileMessage,
          props: {
            domain: 'payments',
            component: 'MobileMessage',
            key: 'MobileMessage',
          },
          component: AsyncDomain,
        },
      ];

  return routes.concat([
    {
      path: 'settings',
      onEnter: onEnterSettings,
      getComponent(location, cb) {
        System.import(
          /* webpackChunkName: "c_user-settings" */ `${BASE_PATH}/src/containers/UserSettings/UserSettings`,
        )
          .then(module => {
            cb(null, module.default);
          })
          .catch(errorLoading);
      },
      childRoutes: settingsChildRoutes,
    },
  ]);
}

function buildMiscResponsivePaymentsRoutes({
  routes,
  onEnterFamilyPlanManagement,
  AsyncDomain,
  redirectToPartnerUpgrade,
  onEnterPartnerUpgradeFlow,
  onEnterVerification,
  onEnterUpgradeFlow,
  onEnterMobileMessage,
  onEnterPaypalCancel,
  onEnterPaypalComplete,
  isMobileWeb,
  isTablet,
}) {
  const miscRoutes = [
    {
      path: 'family/invite',
      onEnter: onEnterFamilyPlanManagement,
      props: {
        domain: 'payments',
        component: 'Subscription',
        key: 'Subscription',
      },
      component: AsyncDomain,
    },
    {
      path: 'family/accept',
      props: {
        domain: 'payments',
        component: 'ProcessFamilyPlanAcceptInvite',
        key: 'ProcessFamilyPlanAcceptInvite',
      },
      component: AsyncDomain,
    },
    {
      path: 'subscription/premium-att',
      onEnter: redirectToPartnerUpgrade,
    },
    {
      path: 'subscription/activate',
      onEnter: onEnterPartnerUpgradeFlow,
      props: {
        domain: 'payments',
        component: 'PaymentsLoading',
        key: 'PaymentsLoading',
      },
      component: AsyncDomain,
    },
    {
      path: 'payment/paypalComplete',
      onEnter: onEnterPaypalComplete,
      props: {
        domain: 'payments',
        component: 'PaymentsLoading',
        key: 'PaymentsLoading',
      },
      component: AsyncDomain,
    },
    {
      path: 'payment/paypalCancel',
      onEnter: onEnterPaypalCancel,
      props: {
        domain: 'payments',
        component: 'PaymentsLoading',
        key: 'PaymentsLoading',
      },
      component: AsyncDomain,
    },
    {
      path: 'payment/:tierSlug',
      onEnter: onEnterUpgradeFlow,
      props: {
        domain: 'payments',
        component: 'Upgrade',
        key: 'Upgrade',
      },
      component: AsyncDomain,
    },
    {
      path: 'payment/:tierSlug/:subTierSlug',
      onEnter: onEnterUpgradeFlow,
      props: {
        domain: 'payments',
        component: 'Upgrade',
        key: 'Upgrade',
      },
      component: AsyncDomain,
    },
    {
      path: 'verify/:tierSlug/:verificationType',
      onEnter: onEnterVerification,
      props: {
        domain: 'payments',
        component: 'Verification',
        key: 'Verification',
      },
      component: AsyncDomain,
    },
    {
      path: 'settings/redeem',
      props: {
        domain: 'payments',
        component: 'Redeem',
        key: 'Redeem',
      },
      component: AsyncDomain,
    },
    {
      path: 'redeem',
      props: {
        domain: 'payments',
        component: 'ProcessSpecialOffer',
        key: 'ProcessSpecialOffer',
      },
      component: AsyncDomain,
    },
    {
      path: 'gift',
      props: {
        domain: 'payments',
        component: 'ProcessSpecialOffer',
        key: 'ProcessSpecialOffer',
      },
      component: AsyncDomain,
    },
    {
      path: 'offer',
      props: {
        domain: 'payments',
        component: 'ProcessSpecialOffer',
        key: 'ProcessSpecialOffer',
      },
      component: AsyncDomain,
      childRoutes: [
        {
          path: ':code',
        },
      ],
    },
    {
      path: 'settings/redeem/congratulations',
      props: {
        domain: 'payments',
        component: 'CongratulationsPage',
        key: 'CongratulationsPage',
      },
      component: AsyncDomain,
    },
    {
      path: 'verify/premium/student/congratulations',
      props: {
        domain: 'payments',
        component: 'ReverificationCongratulationsPage',
        key: 'ReverificationCongratulationsPage',
      },
      component: AsyncDomain,
    },
  ];

  if (isMobileWeb || isTablet) {
    miscRoutes.push({
      path: 'subscription/welcome',
      onEnter: onEnterMobileMessage,
      props: {
        domain: 'payments',
        component: 'WelcomeMobile',
        key: 'WelcomeMobile',
      },
      component: AsyncDomain,
    });
  }

  return routes.concat(miscRoutes);
}

export default {
  buildUpgradeRoutes,
  buildSettingsRoutes,
  buildMobileSettingsRoutes,
  buildMiscResponsivePaymentsRoutes,
};
